import React, {useState, useEffect} from 'react';
import {isMobile} from 'react-device-detect';
import useWindowSize from "../../../hooks/useWindowSize";
import styles from "./Calendar.module.css";
import CalendarDay from "../CalendarDay/CalendarDay";
import SessionIndispo from "../Session/SessionIndispo";
import DisponibilitySelector from "../DisponibilitySelector/DisponibilitySelector";
import statusCode from "../../../components/constants/status_codes";
import Cookies from "js-cookie";
import {CALENDAR_URL_BB, DISPONIBILITY_URL} from "../../constants/urls";
import {useAuth} from "../../../hooks/Auth";


/**
 * Display sessions on a certain time interval
 */

const CalendarPonctuellePanel = (props) => {

    const daysList = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
    const monthsList = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
    const [periodStart, periodStartUpdate] = useState([1, 1, 2020]);
    const [periodEnd, periodEndUpdate] = useState([1, 1, 2020]);
    const [range, rangeUpdate] = useState('week');
    const [filter, setFilter] = useState('indisponible');
    const [month, monthUpdate] = useState(0);
    const [year, yearUpdate] = useState(0);
    const [sessions, setSessions] = useState([[], [], [], [], [], [], []]);
    const [isLoading, isLoadingUpdate] = useState(true);
    const sessionSize = 4;
    const windowSize = useWindowSize();
    const auth = useAuth();




    const updateWidgets = (newSessions) => {
        let time = 0;
        let count = 0;
        let money = 0;
        newSessions.map((day) => {
            day.map((session) => {
                count++;
                time += Math.floor(session.DureeMinutes/60) + (session.DureeMinutes/60 - Math.floor(session.DureeMinutes/60))/10;
                if(session.Code_Statut !== statusCode.cancel_not_paid) money += (Math.floor(session.DureeMinutes/60) + (session.DureeMinutes/60 - Math.floor(session.DureeMinutes/60))/10)*session.RemunerationHoraire;

            });
        });
        props.updateWidgets(time,count,money);
    };

    /*Parse les sessions reçues dans sessions*/
    const parseSessions = (start, end, response, updateFilter) => {
        let newSessions = [];
        let currentDay = start;
        let daysArray = [];

        while ((currentDay[0] !== end[0]) || (currentDay[1] !== end[1])) {
            daysArray.push( [currentDay[0].toLocaleString(undefined, {minimumIntegerDigits:2}), currentDay[1].toLocaleString(undefined, {minimumIntegerDigits:2})] );
            newSessions.push([]);
            currentDay = datePlusDays(1,currentDay);
        }

        if(response.hasOwnProperty('Data')) {
            daysArray.push([currentDay[0].toLocaleString(undefined, {minimumIntegerDigits:2}), currentDay[1].toLocaleString(undefined, {minimumIntegerDigits:2})]);
            newSessions.push([]);
            let data = response.Data;
            for (let i = 0; i < data.length; i++) {
                for(let j = 0; j < daysArray.length; j++){
                    if(
                        (updateFilter === 'indisponible' && data[i].Code_Statut === statusCode.indisponible)
                        || (updateFilter === 'disponible' && data[i].TypeIntervention === statusCode.disponible)
                        || (updateFilter === 'dispo' && data[i].TypeIntervention === statusCode.poctuelle)
                        || (updateFilter === 'dispo' && data[i].TypeIntervention === statusCode.recurrente)
                    ) {
                        if (data[i].SeanceDebut !== "") {
                            if ((data[i].SeanceDebut.split(' ')[0].split('/')[0] === daysArray[j][0]) && (data[i].SeanceDebut.split(' ')[0].split('/')[1] === daysArray[j][1]) && data[i].Code_Statut ===statusCode.indisponible) {
                                newSessions[j].push(data[i])
                           //    console.log(' data[i].Code_Statut BASS ', data[i].SeanceDebut.split(' ')[0].split('/')[0]);
                              //  console.log(' data[i].Code_Statut data ', data[i]);
                                break;
                            }

                        } else {
                            if ((data[i].InterventionDebut.split(' ')[0].split('/')[0] === daysArray[j][0]) && (data[i].InterventionDebut.split(' ')[0].split('/')[1] === daysArray[j][1])) {
                                newSessions[j].push(data[i]);
                                console.log(' data[i].Code_Statut CAR ', data[i].Code_Statut);
                                break;
                            }
                        }
                    }
                }
            }
            updateWidgets(newSessions);

        }

        for(let i = 0; i < newSessions.length; i++) {
            newSessions[i] = sortSessions(newSessions[i]);

        }
        setSessions(newSessions);
        isLoadingUpdate(false);
    };

    /*Tri les sessions en fonctions de l'argument donné*/
    const sortSessions = (sessionsToSort) => {
        let temp = {};
        let i = 0;
        while (i < sessionsToSort.length) {
            let j = i;
            while (j > 0 && sessionsToSort[j-1].SeanceDebut.split(' ')[1] > sessionsToSort[j].SeanceDebut.split(' ')[1])
            {
                temp = sessionsToSort[j];
                sessionsToSort[j] = sessionsToSort[j-1];
                sessionsToSort[j-1] = temp;
                j--;
            }
            i++;
        }
        return sessionsToSort;
    };

    /*Fetch les sessions en fonctions de la période*/
    const updateSessions = (start,end, updateFilter) => {
        isLoadingUpdate(true);
        fetch(CALENDAR_URL_BB,{
            headers:{
                'Accept': 'application/json',
                id: auth.user.id,
                startingDate: start[1].toLocaleString(undefined, {minimumIntegerDigits: 2}) + start[0].toLocaleString(undefined, {minimumIntegerDigits: 2}) + start[2],
                endingDate: end[1].toLocaleString(undefined, {minimumIntegerDigits: 2}) + end[0].toLocaleString(undefined, {minimumIntegerDigits: 2}) + end[2],
                auth: Cookies.get("auth")
            },
            method: 'GET',
        })
            .then(response => response.json())
            .then(response =>
               parseSessions(start, end, response, updateFilter)
            )
            .catch(error => console.log(error));
    };

    const removeSession = (sessionId) => {
        let newSessions = sessions;
        for(let session in newSessions) {
            newSessions[session] = newSessions[session].filter(session => session['$id'] !== sessionId);
        }
        setSessions([...newSessions]);
    }

    /*ComponentDidMount*/
    useEffect(() => {
        if (year === 0) {
            const today = new Date();
            let day = today.getDay();
            if (day === 0) day = 7;
            let [startingDay, startingMonth, startingYear] = dateMinusDays(0,[today.getDate() - day + 1, today.getMonth() + 1, today.getFullYear()]);
            let [endingDay, endingMonth, endingYear] = datePlusDays(0, [today.getDate() + 7 - day, today.getMonth() + 1, today.getFullYear()]);
            periodEndUpdate([endingDay, endingMonth, endingYear]);
            periodStartUpdate([startingDay, startingMonth, startingYear]);
            yearUpdate(today.getFullYear());
            updateSessions([startingDay, startingMonth, startingYear], [endingDay, endingMonth, endingYear], filter);

        }
        //eslint-disable-next-line
    }, []);


    /*Retourne la periode dans laquelle on se trouve*/
    const returnPeriod = () => {
        if (range === 'week') {
            return ('Semaine du ' + periodStart[0] + '/' + periodStart[1] + ' au ' + periodEnd[0] + '/' + periodEnd[1])
        }
        else return (monthsList[month - 1] + ' ' + year);
    };

    const dateMinusDays = (days, [dateDay,dateMonth, dateYear]) => {
        dateDay -= days;
        if (dateDay < 1) {
            if (dateMonth === 3) {
                if (dateYear % 4 === 0)
                    dateDay += 29;
                else
                    dateDay += 28;
                dateMonth--;
            } else if (dateMonth === 5 || dateMonth === 7 || dateMonth === 10 || dateMonth === 12) {
                dateDay += 30;
                dateMonth--;
            } else {
                dateDay += 31;
                dateMonth--;
            }
            if (dateMonth < 1) {
                dateMonth += 12;
                dateYear--;
            }
        }
        return [dateDay,dateMonth, dateYear];
    };

    /*Fait reculer la période d'une semaine*/
    const previousWeek = () => {
        periodStartUpdate(dateMinusDays(7, periodStart));
        periodEndUpdate(dateMinusDays(7, periodEnd));
        updateSessions(dateMinusDays(7, periodStart),dateMinusDays(7, periodEnd), filter);
    };

    /*Fait reculer la période d'un mois*/
    const previousMonth = () => {
        let monthStart = periodStart;
        let monthEnd = periodEnd;
        let monthEndMonday = dateMinusDays(6, monthEnd);

        let newMonth = month - 2;
        if (newMonth < 1) newMonth += 12;

        while ((monthStart[1] !== newMonth) && ((monthStart[0] !== 1) || (monthStart[1] !== newMonth + 1))) {
            monthStart = dateMinusDays(7, monthStart);
        }

        newMonth++;
        if (newMonth > 12) newMonth -= 12;

        while (monthEndMonday[1] !== newMonth) {
            monthEndMonday = dateMinusDays(7, monthEndMonday);
            monthEnd = dateMinusDays(7, monthEnd);
        }

        periodStartUpdate(monthStart);
        periodEndUpdate(monthEnd);
        monthUpdate(newMonth);
        if(newMonth === 12) yearUpdate(year - 1);
        updateSessions(monthStart,monthEnd, filter);
    };

    /*Ajoute le nombre de jours en argument à la date transmise*/
    const datePlusDays = (days,[dateDay,dateMonth,dateYear]) => {
        dateDay += days;
        if (dateMonth === 2) {
            if ((dateYear % 4 === 0) && (dateDay > 29)) {
                dateDay -= 29;
                dateMonth++;
            } else if ((dateYear % 4 !== 0) && (dateDay > 28)) {
                dateDay -= 28;
                dateMonth++;
            }
        } else if (dateMonth === 4 || dateMonth === 6 || dateMonth === 9 || dateMonth === 11) {
            if (dateDay > 30) {
                dateDay -= 30;
                dateMonth++;
            }
        } else if (dateDay > 31) {
            dateDay -= 31;
            dateMonth++;
        }
        if (dateMonth > 12) {
            dateMonth -= 12;
            dateYear++;
        }
        return [dateDay,dateMonth, dateYear];
    };

    /*Fait avancer la période d'une semaine*/
    const nextWeek = () => {
        periodStartUpdate(datePlusDays(7, periodStart));
        periodEndUpdate(datePlusDays(7, periodEnd));
        updateSessions(datePlusDays(7, periodStart),datePlusDays(7, periodEnd), filter);
    };

    /*Fait avancer la période d'un mois*/
    const nextMonth = () => {
        let monthStart = periodStart;
        let monthStartSunday = datePlusDays(6,periodStart);
        let monthEnd= periodEnd;

        let newMonth = month + 1;
        if (newMonth > 12) newMonth -= 12;

        while (monthStartSunday[1] !== newMonth) {
            monthStartSunday = datePlusDays(7, monthStartSunday);
            monthStart = datePlusDays(7, monthStart);
        }

        newMonth++;
        if (newMonth > 12) newMonth -= 12;

        while ((monthEnd[1] !== newMonth) && !isLastDay([monthEnd[0],(month + 1)])) {
            monthEnd = datePlusDays(7, monthEnd);
        }
        newMonth--;
        if (newMonth < 1) newMonth += 12;
        periodStartUpdate(monthStart);
        periodEndUpdate(monthEnd);
        monthUpdate(newMonth);
        if(newMonth === 1) yearUpdate(year + 1);
        updateSessions(monthStart,monthEnd, filter);
    };

    /*Check si le jour qui lui est passé est le dernier du mois*/
    const isLastDay = ([dateDay, dateMonth, dateYear]) => {
        if (dateMonth === 2) {
            if ((dateYear % 4 === 0) && (dateDay === 29)) {
                return true;
            } else if ((dateYear % 4 !== 0) && (dateDay === 28)) {
                return true;
            }
        }
        else if (dateMonth === 4 || dateMonth === 6 || dateMonth === 9 || dateMonth === 11) {
            if (dateDay === 30) {
                return true;
            }
        }
        else if (dateDay === 31) {
            return true;
        }
        return false;
    };

    /*Switch affichage mois/semaine*/
    const zoom = (direction) => {
        if(direction === 'in') {
            rangeUpdate('week');
            periodEndUpdate(datePlusDays(6, periodStart));
            updateSessions(periodStart, datePlusDays(6, periodStart),filter);
        }

        else if (direction === 'out') {
            let currentMonth = periodEnd[1];
            let monthStart = periodStart;
            let monthEnd = periodEnd;
            rangeUpdate('month');

            while ((monthStart[1] === currentMonth) && (monthStart[0] !== 1)) {
                monthStart = dateMinusDays(7 ,monthStart);
            }

            while(monthEnd[1] === periodEnd[1]){
                monthEnd = datePlusDays(7, monthEnd);
            }

            periodStartUpdate(monthStart);
            periodEndUpdate(monthEnd);
            monthUpdate(currentMonth);
            yearUpdate(datePlusDays(7,monthStart)[2]);
            updateSessions(monthStart,monthEnd, filter);
        }
    };

    /*Rempli les creux dans l'agenda*/
    const fillCalendar = (lastSession, newSession) => {
        if (newSession - lastSession > 0) {
            return (<div style={{height: (newSession - lastSession)*sessionSize + 'em'}}/>);
        }
    };

    //Transforme le format HH:MM:SS en H,h
    const hmsToHours = (hms) => {
        let hours = parseInt(hms.split(':')[0],10);
        hours += parseInt(hms.split(':')[1], 10)/60;
        return hours
    };

    //Gère changement de filtre
    const handleOptionSelect = (event) => {
        if(event.target.value === 'dispo') zoom('in');
        setFilter(event.target.value);
        updateSessions(periodStart,periodEnd, event.target.value);
    };

    //Retourne une couleur en fonction d'une string
    // noinspection DuplicatedCode
    const colorHash = (inputString) => {
        let sum = 0;

        // eslint-disable-next-line
        for(let i in inputString){
            sum += inputString.charCodeAt(i);
        }

        let r = ~~(('0.'+Math.sin(sum+1).toString().substr(6))*256);
        let g = ~~(('0.'+Math.sin(sum+2).toString().substr(6))*256);
        let b = ~~(('0.'+Math.sin(sum+3).toString().substr(6))*256);

        let rgb = "rgb("+r+", "+g+", "+b+")";
        let hex = "#";

        hex += ("00" + r.toString(16)).substr(-2,2).toUpperCase();
        hex += ("00" + g.toString(16)).substr(-2,2).toUpperCase();
        hex += ("00" + b.toString(16)).substr(-2,2).toUpperCase();

        return {
            r: r
            ,g: g
            ,b: b
            ,rgb: rgb
            ,hex: hex
        };
    };

    /*Rend le calendrier en fonction de la période*/
    const renderCalendar = () => {
        if (range === 'week') {
            let lastSession = 8;
            return (
                <div className={"w-full flex text-center"}>
                    {sessions.map((day, i) =>

                        <div key={i} className={"w-full"}>
                            <p className={"font-semibold text-white bg-blue-900 bg-opacity-90"}>
                                {windowSize.width < 900 ? daysList[i][0] + " " + datePlusDays(i, periodStart)[0] : daysList[i] + " " + datePlusDays(i, periodStart)[0]}
                            </p>
                            <div style={{height:'36em'}}>
                                <p style={{display: 'none'}}>
                                    {lastSession = 9.1}</p>
                                {day.map((session, j) =>

                                    <div key={j}>
                                       {fillCalendar(lastSession, session.SeanceDebut !== '' ? hmsToHours(session.SeanceDebut.split(' ')[1]) : hmsToHours(session.InterventionDebut.split(' ')[1]))}

                                        <SessionIndispo
                                            title={session.Evenement === "" ? session.Programme : session.Evenement}
                                            startingTime={session.SeanceDebut !== '' ? session.SeanceDebut.split(' ')[1] : session.InterventionDebut.split(' ')[1]}
                                            endingTime={session.SeanceFin !== '' ? session.SeanceFin.split(' ')[1] : session.InterventionFin.split(' ')[1]}
                                            rgb={session.Code_Statut === statusCode.unavailable ? "rgb(92,92,92)" : colorHash(session.TypeIntervention).rgb}
                                            size={sessionSize}
                                            minimized={true}
                                            time={300}
                                            status={session.Statut_Libelle}
                                            idIntervention={session.IdIntervention}
                                            callback={() => removeSession(session['$id'])}
                                            seanceDebut={session.SeanceDebut}
                                            seanceFin={session.SeanceFin}
                                            idUtilisateur={session.IdUtilisateur}
                                            typeIntervention={session.TypeIntervention}
                                        />

                                        <div  style={{display: 'none' }}>
                                            {lastSession = (session.SeanceFin !== '' ? hmsToHours(session.SeanceFin.split(' ')[1]) : hmsToHours(session.InterventionFin.split(' ')[1]))}</div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            );
        }

        else {
            let currentDay = periodStart;
            let dayCount = 0;
            let renderMonth = [];
            let renderWeek = [];

            while ((currentDay[0] !== periodEnd[0]) || (currentDay[1] !== periodEnd[1])) {
                renderWeek.push(<CalendarDay key={dayCount} date={currentDay} className={styles.day} currentMonth={month} sessions={sessions[dayCount]}/>);
                currentDay = datePlusDays(1,currentDay);
                dayCount++;
                if(dayCount % 7 === 0) {
                    renderMonth.push(<div key={"week " + dayCount/7} className={styles.week}>{renderWeek}</div>);
                    renderWeek=[];
                }
            }
            renderWeek.push(<CalendarDay key={"week " + dayCount/7} date={currentDay} className={styles.day}/>);
            renderMonth.push(<div key={"month"} className={styles.week}>{renderWeek}</div>);

            return (
                <div>
                    <div className={"flex"}>
                        {daysList.map((day, i) =>
                            <div key={i} className={styles.day}>
                                <p className={"text-center font-semibold w-full text-white bg-blue-900 bg-opacity-90"}>{isMobile ? day[0] : day}</p>
                            </div>
                        )}
                    </div>
                    <div >
                    </div>
                    {renderMonth}
                </div>
            );
        }
    };

    const renderDispo = () => {
        let today = new Date();
        today = [today.getDate() + 1, today.getMonth() + 1, today.getFullYear()];
        let currentDay = periodStart;
        let daysArray = [];
        let minimumDate = datePlusDays(21, today);
        let result=[];

        while ((currentDay[0] !== periodEnd[0]) || (currentDay[1] !== periodEnd[1])) {
            daysArray.push( [currentDay[0].toLocaleString(undefined, {minimumIntegerDigits:2}), currentDay[1].toLocaleString(undefined, {minimumIntegerDigits:2}), currentDay[2].toString()] );
            currentDay = datePlusDays(1,currentDay);
        }
        daysArray.push( [currentDay[0].toLocaleString(undefined, {minimumIntegerDigits:2}), currentDay[1].toLocaleString(undefined, {minimumIntegerDigits:2}), currentDay[2].toString()] );

        result.push(
            <div className={"text-white bg-opacity-90 bg-blue-900 text-center flex flex-col justify-between pt-6"} key={"hours"}>
                <p>8h</p>
                <p>13h</p>
                <p>18h</p>
            </div>
        )
        for(let i = 0; i< 7; i++) {
            result.push(
                <div className={styles.day} key={i}>
                    <p className={"w-full text-white font-semibold bg-blue-900 bg-opacity-90 text-center"}>
                        {windowSize.width < 1000 ? daysList[i][0] + " " + daysArray[i][0] : daysList[i] + " " + daysArray[i][0]}
                    </p>
                    <DisponibilitySelector
                        period={'AM'}
                        date={daysArray[i]}
                        editable={dispoIsEditable(minimumDate, daysArray[i], sessions[i],'AM')}
                        updateDispo={updateDispo}
                        alreadyChecked={checkedDispo(sessions[i], 'AM')}
                        key={i + ' AM'}
                    />

                    <DisponibilitySelector
                        period={'PM'}
                        date={daysArray[i]}
                        editable={dispoIsEditable(minimumDate, daysArray[i], sessions[i], 'PM')}
                        updateDispo={updateDispo}
                        alreadyChecked={checkedDispo(sessions[i], 'PM')}
                        key={i + ' PM'}

                    />
                </div>
            )
        }
        return(
            <div className={"flex"}>
                {result}
            </div>
        )
    };



    const updateDispo = (date, period) => {

        fetch(DISPONIBILITY_URL, {
            method:'POST',
            headers:{
                'Content-Type':'application/json',
                auth: Cookies.get("auth")
            },
            body:JSON.stringify({
                userId : auth.user.id,
                start: date[1] + date[0] + date[2],
                end: date[1] + date[0] + date[2],
                period: period,
                actionIntervention:'C',
                week:1
            })

        })
            .then(response => console.log("Status BOUBII",response.status))
            .catch(err => console.log(err));
    };

    const dispoIsEditable = (minimumDate, testDate, todaySessions,period) => {
        let dateValid;
        let emptyPeriod;
        if(parseInt(testDate[2]) > parseInt(minimumDate[2])) dateValid = true;
        else if(parseInt(testDate[2]) < parseInt(minimumDate[2])) dateValid = false;
        else {
            if (parseInt(testDate[1]) > parseInt(minimumDate[1])) dateValid = true;
            else if (parseInt(testDate[1]) < parseInt(minimumDate[1])) dateValid = false;
            else dateValid =  (parseInt(testDate[0]) >= parseInt(minimumDate[0]))
        }

        if (todaySessions !== undefined){
            if(period === 'AM'){
                emptyPeriod = !todaySessions.some(seance => seance.SeanceDebut.split(' ')[1].split(':')[0] < 13);
            }
            else {
                emptyPeriod = !todaySessions.some(seance => seance.SeanceDebut.split(' ')[1].split(':')[0] >= 13);
            }
        }

        return (dateValid && emptyPeriod);
    };

    const checkedDispo = (todaySessions, period) => {
        if (todaySessions !== undefined) {
            if (period === 'AM') {
                return todaySessions.some(seance => seance.Code_Statut === statusCode.unavailable && seance.SeanceDebut.split(' ')[1] === "08:00:00");
            } else {
                return todaySessions.some(seance => seance.Code_Statut === statusCode.unavailable && seance.SeanceDebut.split(' ')[1] === "13:00:00");
            }
        }
    };

    const loadingSessions = () => {
        return(
            <div className={styles.loading}>
                Chargement de l'emploi du temps...
            </div>
        )
    };

    return(
            <div className={"w-full border-2 border-blue-900"}>
                <div className={"flex justify-between items-centers p-2"}>

                    <div className={styles.filterContainer}>
                        <select onChange={handleOptionSelect} className={styles.filterSelection}>
                            <option value={'indisponible'}>Planning </option>
                            <option value={'dispo'}> Poser  </option>*/}
                        </select>
                    </div>

                    <div className={styles.time}>
                        <div className={isLoading ? styles.leftArrowDisabled : styles.leftArrow} onClick={isLoading ? null : (range === 'week' ? () => previousWeek() : previousMonth)}/>
                        <div className={styles.title}><b>{returnPeriod()}</b></div>
                        <div className={isLoading ? styles.rightArrowDisabled : styles.rightArrow} onClick={isLoading ? null : (range === 'week' ? () => nextWeek() : nextMonth)}/>
                    </div>

                    <div className={styles.zoomContainer} style={filter === 'dispo' ? {display: 'none'} : null}>
                        <div onClick={range === 'month' ? null : () => zoom('out')}
                             className={range === 'month' ? styles.zoomEnabled :styles.zoomDisabled}>
                            <b>Mois</b>
                        </div>

                        <div onClick={range === 'month' ? () => zoom('in') : null}
                             className={range === 'month' ? styles.zoomDisabled : styles.zoomEnabled}>
                            <b>Semaine</b>
                        </div>
                    </div>
                </div>
                {isLoading ? loadingSessions() : (filter === 'dispo' ? renderDispo() : renderCalendar())}
            </div>

    )
};

export default CalendarPonctuellePanel;